module.exports = __webpack_public_path__ + "img/andong_gallery2.d8266123.jpg";